import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import {
  KeycloakLoginTransition,
  LoginLoading,
} from "../components/auth/KeycloakLoginTransition";

const Login = ({ state }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();

  const from = state?.from?.pathname || location.state?.from?.pathname || "/";

  useEffect(() => {
    console.log("Login component mounted");

    if (currentUser) {
      navigate(from, { replace: true });
    }
  }, [currentUser, navigate, from]);

  if (!currentUser) {
    return <KeycloakLoginTransition returnPath={from} />;
  }

  return <LoginLoading />;
};

export default Login;
